var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticStyle:{"height":"100%"}},[_c('el-header',[_vm._t("header")],2),_vm._v(" "),_c('el-container',[_c('el-main',[_vm._t("main")],2),_vm._v(" "),_c('el-aside',[_vm._t("aside")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }